import { BotId } from '@feedyou/schema'
import { GeneralErrors } from '@feedyou/utils'
import { environmentGroupForBotSelector } from '@features/serverBots/selectors/environmentGroupForBotSelector'

import { FeedbotThunk } from '../../../../../store/types'
import {
  confirmArchivation,
  confirmArchivationDespiteNonNativeHostingId
} from './confirmArchivation'
import { doesBotHaveNativeApiUrl } from '../utils'
import { callAsyncWithRetry, FAILED } from '../../../../../lib/async/callAsyncWithRetry'
import { getFullBotMetadataForBot } from '../../getterThunks/getFullBotMetadataForBot'
import { endpointHelpers } from '../../../endpointHelpers'
import {
  alertHavingUnsavedChanges,
  alertHavingUnsavedChangesForTestEnvironment
} from '../../../utils/bootbox'

export const initiateBotArchivation =
  (botId: BotId): FeedbotThunk<Promise<'success' | 'failure' | 'abort'>> =>
  async (dispatch, getState) => {
    const metadata = await dispatch(getFullBotMetadataForBot(botId))

    const confirmed = await confirmArchivation(botId)
    if (!confirmed) {
      return 'abort'
    }

    if (metadata?.apiUrl && !doesBotHaveNativeApiUrl(botId, metadata?.apiUrl)) {
      const isConfirmed = await confirmArchivationDespiteNonNativeHostingId(
        botId,
        metadata?.apiUrl!
      )

      if (!isConfirmed) {
        return 'abort'
      }
    }

    const result = await callAsyncWithRetry({
      actionDescription: 'archive',
      asyncFunction: () =>
        dispatch(endpointHelpers.archiveBot.initiate({ botId }))
          .unwrap()
          .catch(err => {
            if (err.data === GeneralErrors.UnsavedBotChanges) {
              alertHavingUnsavedChanges()
              return 'success'
            }
            if (err.data === GeneralErrors.UnsavedBotTestEnvironmentChanges) {
              const { testName } = environmentGroupForBotSelector(botId)(getState())

              alertHavingUnsavedChangesForTestEnvironment(testName)
              return 'success'
            }
            return 'failure'
          })
    })

    return result === FAILED ? 'failure' : 'success'
  }
